<div class="container"
  #container>
  @if (isReady) {
    <aa-chart [dimensions]="dimensions"
      [title]="chartingService.config.title">
      @if (chartingService.config.rendering.gridHor) {
        <svg:g aaGridHor
          [dimensions]="dimensions"
          [scale]="yScale">
          </svg:g>
        }
        @if (chartingService.config.rendering.gridVer) {
          <svg:g aaGridVer
            [dimensions]="dimensions"
            [scale]="xScale">
            </svg:g>
          }
          <svg:g aaAxis
            orientation="x"
            [dimensions]="dimensions"
            [scale]="xScale"
            [formatTick]="xFormatTick"
            [label]="chartingService.config.xLabel">
            </svg:g>
            <svg:g aaAxis
              orientation="y"
              [dimensions]="dimensions"
              [scale]="yScale"
              [formatTick]="yFormatTick"
              [label]="chartingService.config.yLabel">
              </svg:g>
              @for (serie of series; track serie) {
                <svg:g>
                  <svg:g aaLine
                    [dimensions]="dimensions"
                    [serie]="serie">
                    </svg:g>
                    <svg:g aaCircles
                      [dimensions]="dimensions"
                      [serie]="serie"
                      [keyAccessor]="keyAccessor">
                      </svg:g>
                      </svg:g>
                    }
                    <svg:g aaTooltip
                      [hovered]="hovered"
                      [dimensions]="dimensions"
                      [tooltipData]="tooltipData"
                      [formatTick]="yFormatTick">
                      </svg:g>
                      <svg:g aaLegend
                        [dimensions]="dimensions"
                        [series]="series"
                        [config]="chartingService.config.legend"
                        (toggleSerieVisibility)="onToggleSerieVisibility()">
                        </svg:g>
                        <svg:g aaListeningZone
                          [dimensions]="dimensions"
                          (mousePosition)="onMousePosition($event)"
                          (hovered)="onHovered($event)">
                          </svg:g>
                        </aa-chart>
                      }
                    </div>
